import { z4 } from '@fiverr-private/forms';
import {
    createProfileSetupSchema as createProfileSetupSchemaCore,
    FIRST_LAST_NAME_REGEX,
} from '@fiverr-private/identification_core';
import { translate } from '../../../utils/translate';

export const createProfileSetupSchema = () =>
    createProfileSetupSchemaCore().extend({
        firstName: z4
            .string()
            .min(1, { error: translate('steps.profile_setup.first_name_hint') })
            .refine((value) => FIRST_LAST_NAME_REGEX.test(value), {
                error: translate('validation.profile_setup.first_name_syntax'),
            }),
        lastName: z4
            .string()
            .min(1, { error: translate('steps.profile_setup.last_name_hint') })
            .refine((value) => FIRST_LAST_NAME_REGEX.test(value), {
                error: translate('validation.profile_setup.last_name_syntax'),
            }),
    });

export type ProfileSetupFormSchema = z4.infer<ReturnType<typeof createProfileSetupSchema>>;

export const FieldName: Record<keyof ProfileSetupFormSchema, keyof ProfileSetupFormSchema> = {
    firstName: 'firstName',
    lastName: 'lastName',
    username: 'username',
};
